export default __webpack_public_path__ + "static/media/1.b4c2c53c.jpg";